import { DataFiltersType } from 'typings/shareholders.type';
import { dictFilter } from 'utils/common.util';
import request from 'services/request';
import { securityInfoUrl } from 'routes/security.routes';
import {
  DailyChangesUrl,
  SecurityUrl,
  ShareholdersSummaryUrl,
} from 'routes/shareholders.routes';

export const getSecurityInformationAction = async (
  set,
  securityId: string,
): Promise<void> => {
  set({
    securityInfoData: null,
    securityInfoLoading: true,
    securityInfoError: false,
  });

  const response = await request.get(securityInfoUrl(securityId));
  response.ok
    ? set({ securityInfoData: response.data.data, securityInfoLoading: false })
    : set({ securityInfoError: true, securityInfoLoading: false });
};

export const getSummaryDataAction = async (
  set,
  securityId: string,
): Promise<void> => {
  set({ summaryData: null, summaryLoading: true, summaryError: false });

  const response = await request.get(ShareholdersSummaryUrl(securityId));
  response.ok
    ? set({ summaryData: response.data.data, summaryLoading: false })
    : set({ summaryLoading: false, summaryError: true });
};

export const getShareholdersTableDataAction = async (
  set,
  securityId,
  isSimple,
): Promise<void> => {
  isSimple
    ? set({
        securitySimpleData: null,
        securitySimpleLoading: true,
        securitySimpleError: false,
      })
    : set({
        securityCombinedData: null,
        securityCombinedLoading: true,
        securityCombinedError: false,
      });

  const response = await request.get(SecurityUrl(securityId, isSimple), {
    ordering: '-percentage',
  });

  isSimple
    ? response.ok
      ? set({
          securitySimpleData: response.data.data,
          securitySimpleLoading: false,
        })
      : set({
          securitySimpleLoading: false,
          securitySimpleError: true,
        })
    : response.ok
    ? set({
        securityCombinedData: response.data.data,
        securityCombinedLoading: false,
      })
    : set({
        securityCombinedLoading: false,
        securityCombinedError: true,
      });
};

export const deleteShareholdersTableDataAction = (set): void => {
  set({
    securitySimpleData: null,
    securityCombinedData: null,
  });
};

export const saveShareholdersFilterAction = (
  set,
  {
    tabName,
    searchedShareholder,
    isSimpleStatus,
    individualFilter,
    entersAndExits,
  }: DataFiltersType,
): void => {
  // The filter of each tab in shareholders must be saved with the name of the same tab
  set({
    [`${tabName}DataFilters`]: dictFilter(
      {
        tabName,
        searchedShareholder,
        isSimpleStatus,
        individualFilter,
        entersAndExits,
      },
      (key) => key !== 'tabName',
    ),
  });
};

export const getDailyChangeDataAction = async (
  set,
  isSimple: boolean,
  shareholderName?: string,
): Promise<void> => {
  isSimple
    ? set({
        dailyChangeSimpleData: null,
        dailyChangeLoading: true,
        dailyChangeSimpleError: false,
      })
    : set({
        dailyChangeCombinedData: null,
        dailyChangeLoading: true,
        dailyChangeCombinedError: false,
      });

  const response = await request.get(DailyChangesUrl(isSimple), {
    ordering: '-value_of_changes',
    ...(shareholderName ? { search: shareholderName } : {}),
  });

  isSimple
    ? response.ok
      ? set({
          dailyChangeSimpleData: response.data.data,
          dailyChangeLoading: false,
        })
      : set({
          dailyChangeLoading: false,
          dailyChangeSimpleError: true,
        })
    : response.ok
    ? set({
        dailyChangeCombinedData: response.data.data,
        dailyChangeLoading: false,
      })
    : set({
        dailyChangeLoading: false,
        dailyChangeCombinedError: true,
      });
};

export const deleteDailyChangesDataAction = (set): void => {
  set({
    dailyChangeSimpleData: null,
    dailyChangeCombinedData: null,
  });
};
